module.exports = __webpack_public_path__ + "player-smile.09f4d6c4.png";